import React from 'react';

import {connect} from 'react-redux';
import {push} from 'react-router-redux';

import {LOCATION_LIST_URL} from 'config/urls';

import {getAuthToken} from 'utils/localStorage';

const AnonymousRequired = WrappedComponent => {
  class Wrapper extends React.Component<any> {
    componentDidMount() {
      const {dispatch} = this.props;

      const token = getAuthToken();

      if (token) {
        dispatch(push(LOCATION_LIST_URL));
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return connect()(Wrapper);
};

export default AnonymousRequired;
